import { TextField, Typography, Container, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react';
import Botao from '../Botao/Botao';
import Modal from '../Modal/Modal';
import { BotaoContainer, ModalContainerEditCommission } from './styles';
import CommissionSalesService from '../../services/CommissionSalesService';
import Snackbars from '../Snackbars';

interface SecondCopyCommissionModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  onSuccess: () => void;
  idVenda: string;
  idParcela: string;
  currentDueDate: string;
}

const SecondCopyCommissionModal = (props: SecondCopyCommissionModalProps): any => {
  const { isModalOpen, onClose, onOpen, idVenda, idParcela, currentDueDate, onSuccess } = props;

  const [newDueDate, setNewDueDate] = useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarProps, setSnackbarProps] = React.useState<{
    message: string;
    type: 'success' | 'error' | 'info';
  }>({
    message: '',
    type: 'info',
  });

  React.useEffect(() => {
    if (isModalOpen && onOpen) {
      onOpen();
    }
  }, [isModalOpen, onOpen]);

  const handleSnackbarClose = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleGenerateSecondCopyCommissionSales = async () => { 
    setIsLoading(true);
    try {
      if (new Date(newDueDate) <= new Date()) {
        setSnackbarProps({
          message: 'A nova data de vencimento deve ser uma data futura.',
          type: 'error',
        });
        setSnackbarOpen(true);
        return;
      }

      await CommissionSalesService.generateSecondCopyCommissionSales(idVenda, idParcela, newDueDate);

      setSnackbarProps({
        message: '2° via de comissão gerada com sucesso!',
        type: 'success',
      });
      setSnackbarOpen(true);
      if(onSuccess) {
        onSuccess();
      }

      setNewDueDate('');

    } catch (error) {
      setSnackbarProps({  
        message: 'Erro ao gerar 2° via de comissão',
        type: 'error',
      });
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        width={440}
        onClose={onClose}
      >
        <ModalContainerEditCommission>
          <Typography variant="h6">Emitir 2° Via</Typography>

          <Container className="field-group">
            <Typography variant="subtitle2">Data atual de vencimento: {currentDueDate}</Typography>
            <TextField
              label="Nova data de vencimento"
              variant="outlined"
              size="small"
              type="date"
              value={newDueDate}
              onChange={(e) => setNewDueDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              className="date-input"
            />
          </Container>

          <BotaoContainer>
            <Botao
              tipo="salvar"
              tamanho="medio"
              className="btn"
              onClick={handleGenerateSecondCopyCommissionSales}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Salvar'
              )}
            </Botao>
            <Botao
              tamanho="medio"
              className="btn"
              onClick={onClose}
            >
              Cancelar
            </Botao>
          </BotaoContainer>
        </ModalContainerEditCommission>
      </Modal>
      <Snackbars
        type={snackbarProps.type}
        handleClose={handleSnackbarClose}
        open={snackbarOpen}
      >
        {snackbarProps.message}
      </Snackbars>
    </>
  );
};

export default SecondCopyCommissionModal;